<template>
  <div>
    <el-dialog
      :title="warningData.length > 0 ? warningData[warningIndex].titleName : ''"
      :visible.sync="warningShow"
      width="80%"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div>
        <el-carousel ref="carousel" :autoplay="false" arrow="never" :height="tableHeight + 'px'" indicator-position="none" @change="changeCarousel">
          <el-carousel-item v-for="(items,index) in warningData.length" :key="index">
            <span v-if="warningData[warningIndex].titleName === '首日回本预警'" style="display:inline-block;width:100%">
              <span style="width:60%;display:inline-block;text-align:right;">
                {{ warningData[warningIndex].message.list.length > 0?'以下是回本不达标的渠道，要及时调整，继续加油哦~':'昨天渠道全部达标，小伙伴们再接再厉~' }}
              </span>
              <span style="text-align:right;width:39%;display:inline-block;">
                <el-button v-if="warningData[warningIndex].message.list.length > 0" type="primary" icon="el-icon-download" @click="exportList(warningData[warningIndex].message.list[0]['game_reg_date'])">添加导出任务</el-button>
              </span>
            </span>

            <span style="float:right;color:#888;margin-bottom:5px">更新时间：{{ warningData.length > 0 ? parseTime(warningData[warningIndex].message.time):'' }}</span>
            <div class="warning-carousel-table">
              <el-table
                ref="warningTable"
                v-loading="loading"
                :data="warningData[warningIndex].message.list.slice((warningData[warningIndex].page - 1) * warningData[warningIndex].rows, warningData[warningIndex].page * warningData[warningIndex].rows)"
                border
                stripe
                highlight-current-row
                :header-cell-style="{background:'#f5f7fa'}"
                max-height="420px"
                :cell-class-name="cellClassName"
              >
                <template v-if="warningData.length > 0">
                  <el-table-column
                    v-for="item in warningData[warningIndex].tableColumn"
                    :key="item.label"
                    align="center"
                    :prop="item.prop"
                    :label="item.label"
                    show-overflow-tooltip
                    :min-width="item.width"
                  >
                    <template #default="scope">
                      {{
                        // 平台需要转中文
                        item.label === '平台' ? $global.platformMap[scope.row[item.prop]] :
                        item.type === 'percent' ? toFixed(scope.row[item.prop] * 100) +'%' : scope.row[item.prop]
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="warningData[warningIndex].titleName === '首日回本预警' && analyseBtnVisible"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button type="text" :disabled="getRowAnalyseDisabled(scope.row)" @click="getAlertPayData(scope.row)">分析</el-button>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
              <el-pagination
                v-show="warningData[warningIndex].message.list.length > warningData[warningIndex].rows"
                :total="warningData[warningIndex].total"
                :current-page.sync="warningData[warningIndex].page"
                :page-size="warningData[warningIndex].rows"
                style="margin-top:10px; text-align:right;"
                background
                layout=" prev, pager, next"
                @current-change="(value) => { handleSizeChange(value,warningIndex) }"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="warningIndex > 0" type="primary" @click="prev">上一页</el-button>
        <el-button v-if="warningIndex < warningData.length-1" type="primary" @click="next">下一页</el-button>
        <el-button v-if="warningIndex === warningData.length-1" type="primary" @click="closeWarning">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="分析结果"
      :visible.sync="analyseDialogVisible"
      :close-on-click-modal="false"
      top="5vh"
      width="92%"
      @closed="analyseTracking(3)"
    >
      <TargetAnalyse
        :row-data="analyseRowData"
        :analyse-type-name="analyseTypeName"
        :date-min="dateMin"
        :date-max="dateMax"
        :exception-data="exceptionData"
        :dimension-column="dimensionColumn"
        :search-analyse-type="'first_day_roi'"
      />
    </el-dialog>
  </div>
</template>

<script>
import { toFixed, parseTime, deepClone } from '@/utils'
import { dataList } from './matchWarning'
import { addExportTask } from '@/api/common'
import { getOverviewPermission, exceptionDetail } from '@/api/dms/market'
import { analyseTracking } from '@/utils/tracking'
import TargetAnalyse from '@/views/dms/market/components/targetAnalyse'
export default {
  name: 'WarningMessage',
  components: {
    TargetAnalyse
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      warningData: [],
      warningShow: false,
      warningIndex: 0,
      tableHeight: 500,
      loading: false,
      analyseDialogVisible: false,
      analyseTypeName: '',
      dateMin: '',
      dateMax: '',
      exceptionData: null,
      analyseRowData: null,
      dimensionColumn: {
        platform: '平台',
        plat_id: '游戏类型',
        root_game_id: '根游戏',
        main_game_id: '主游戏',
        game_id: '子游戏',
        agent_leader: '负责人',
        agent_group_id: '渠道组',
        agent_id: '渠道ID'
      },
      analyseBtnVisible: false
    }
  },
  watch: {
    data: {
      handler(newData, oldValue) {
        if (!(newData instanceof Object)) {
          return false
        }
        let status = false
        const warningData = deepClone(this.warningData)
        warningData.filter(item => {
          if (item.title === newData.title) {
          // 说明已经存在过，只需要覆盖message
            item.message = newData.message
            item.page = 1
            item.rows = 50
            item.total = newData.message.list.length
            status = true
            this.warningShow = true
          }
        })
        if (!status) {
        // 说明没有存在过
          if (dataList[newData.title]) {
            newData.titleName = dataList[newData.title].title
            newData.tableColumn = []
            newData.page = 1
            newData.rows = 50
            newData.total = newData.message.list.length

            for (const key in dataList[newData.title].map) {
              newData.tableColumn.push({
                prop: key,
                label: dataList[newData.title].map[key].name,
                type: dataList[newData.title].map[key].type
              })
            }
            warningData.push(newData)
            this.warningShow = true
          }
        }

        this.warningData = deepClone(warningData)

        if (!this.warningShow) {
          this.$message.error('格式错误')
        } else {
          this.$nextTick(_ => {
            this.tableHeight = document.getElementsByClassName('warning-carousel-table')[this.warningIndex].clientHeight + 100
          })
        }
      },
      deep: true
    }
  },
  created() {
    if (this.$store.getters.permission_uri.includes('/dms/market/overview')) {
      this.getOverviewPermission()
      this.analyseBtnVisible = true
    }
  },
  methods: {
    toFixed,
    parseTime,
    analyseTracking,
    handleSizeChange(value, index) {
      this.warningData[index].page = value
    },
    getRowAnalyseDisabled(rowData) {
      const deviation = (parseFloat(rowData.first_day_roi) / 100) / (parseFloat(rowData.mean_first_day_pay_roi)) - 1
      if (parseFloat(rowData.day_cost_money) > 1000 && deviation < -0.2) {
        return false
      }
      return true
    },
    getOverviewPermission() {
      getOverviewPermission().then(res => {
        this.dimensionFilter = res.data.dimension_filter_list
        this.dimensionMap = res.data.dimension_list
      })
    },
    getAlertPayData(rowData) {
      const param = {
        target: [],
        aggregation_time: '按日',
        dimension_type: '2',
        start_time: rowData.game_reg_date,
        end_time: rowData.game_reg_date,
        cost_money: rowData.day_cost_money,
        dimension: ['platform', 'plat_id', 'root_game_id', 'main_game_id', 'game_id', 'agent_leader', 'agent_group_id', 'agent_id', 'date'],
        dimension_filter: {},
        exception_target: 'first_day_roi'
      }
      const dimension_list = {}

      for (const key in this.dimensionMap) {
        this.dimensionMap[key].forEach(item => {
          dimension_list[item.column] = item
        })
      }

      param.dimension.forEach(dimension => {
        if (dimension !== 'date') {
          const name = dimension_list[dimension].name
          for (const key in this.dimensionFilter) {
            if (this.dimensionFilter[key].name === name) {
              if (!param.dimension_filter[key]) {
                param.dimension_filter[key] = deepClone(this.dimensionFilter[key])
                const isArr = param.dimension_filter[key].condition === 'in'
                param.dimension_filter[key].value = isArr ? [] : ''
              }
            }
          }
        }
      })

      for (const key in param.dimension_filter) {
        let value = ''
        let column = ''
        const isArr = param.dimension_filter[key].condition === 'in'
        if (param.dimension_filter[key].column.indexOf('-') !== -1) {
          if (rowData.platform) {
            column = param.dimension_filter[key].column.split('-')[1]
            value = this.$global.platformMap[rowData.platform] + '-' + this.filterValue(column, rowData)
          }
        } else {
          column = param.dimension_filter[key].column
          value = this.filterValue(column, rowData)
        }

        if (param.dimension.includes(column)) {
          if (isArr) {
            if (!param.dimension_filter[key].value.includes(value)) {
              param.dimension_filter[key].value.push(value)
            }
          } else {
            param.dimension_filter[key].value = value
          }
        }
      }
      analyseTracking(2)
      this.loading = true
      exceptionDetail(param).then(res => {
        this.analyseRowData = rowData
        this.exceptionData = res
        this.dateMin = param.game_reg_date
        this.dateMax = param.game_reg_date
        this.analyseDialogVisible = true
      }).finally(() => {
        this.loading = false
      })
    },
    filterValue(key, data) {
      // 游戏类型转为中文名
      return key === 'plat_id' ? Number(data[key]) > 8 ? '' : this.$global.platIdMap.filter(res => { return res.value === Number(data[key]) })[0].label || ''
        // id 与 name 的结合
        : key.indexOf('_id') > -1 ? data[key] + (data[key.replace('_id', '_name')] ? '-' + data[key.replace('_id', '_name')] : '')
          // 平台转为中文名
          : key === 'csite' ? data[key] + '-' + data['csite_name']
            : key === 'platform' ? this.$global.platformMap[data['platform']]
              : key === 'device_price_section' ? this.getPriceSection(data[key])
                : key === 'is_simulator' || key === 'is_root_reg' ? data[key] === '0' ? '否' : '是' : data[key]
    },
    exportList(time) {
      const date = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
      addExportTask({ game_reg_date: time, router: '/notice/alert-pay-data' }, '首日回本预警-' + date).then(response => {
        this.$message.success('添加任务成功')
        this.$store.dispatch('app/toggleDrawerRightMenu', true)
      })
    },
    changeCarousel(newIndex) {
      this.warningIndex = newIndex
      this.$nextTick(_ => {
        this.tableHeight = document.getElementsByClassName('warning-carousel-table')[this.warningIndex].clientHeight + 100
      })
    },
    closeWarning() {
      this.warningShow = false
      this.warningIndex = 0
      this.warningData = []
    },
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'diff') {
        if (row[column.property]) {
          const value = Number(row[column.property].replace('%', ''))
          let color = ''
          if (value <= -50) {
            color = 'differ-class-red'
          }
          if (value > -50 && value <= -30) {
            color = 'differ-class-pink-double'
          }
          if (value > -30 && value <= -20) {
            color = 'differ-class-pink'
          }
          return color
        } else {
          return ''
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .differ-class-red{
    background: rgb(243,141,141)!important;
  }
  .differ-class-pink{
    background: rgb(243,209,179)!important;
  }

  .differ-class-pink-double{
    background: rgb(243,185,163)!important;
  }
</style>
